import React, { useState, useEffect } from "react";

import Form from "react-bootstrap/Form";

import ImageUploader from "../../imageuploader";

import Presets from "./Presets";

import { apiDelete, apiGet, apiPost, apiPut } from "../../../api/server"

const EventRow = (props) => {

   const [date1, setDate1] = useState(props.prefill1?.date || "DATE, TIME + LOCATION")
   const [info1, setInfo1] = useState(props.prefill1?.info || "Information here")
   const [buttonText1, setButtonText1] = useState(props.prefill1?.buttonText || "Book")
   const [buttonLink1, setButtonLink1] = useState(props.prefill1?.buttonLink || "https://www.businessbutleruk.com")
   const [image1, setImage1] = useState(props.prefill1?.image || "https://business-butler-media.s3.eu-west-2.amazonaws.com/email-images/placeholder.png")
   const [date2, setDate2] = useState(props.prefill2?.date || "DATE, TIME + LOCATION")
   const [info2, setInfo2] = useState(props.prefill2?.info || "Information here")
   const [buttonText2, setButtonText2] = useState(props.prefill2?.buttonText || "Book")
   const [buttonLink2, setButtonLink2] = useState(props.prefill2?.buttonLink || "https://www.businessbutleruk.com")
   const [image2, setImage2] = useState(props.prefill2?.image || "https://business-butler-media.s3.eu-west-2.amazonaws.com/email-images/placeholder.png")
   const [imageOptions, setImageOptions] = useState([])

    function refreshImageOptions(){
        console.log("hello")
        setImageOptions([])
        apiGet(`intranetfileupload/geteventemailimages`).then(res => {
            res.json().then(data => {
                
                setImageOptions(data)
            })
        })
    }

   

   useEffect(() => {
    apiGet(`intranetfileupload/geteventemailimages`).then(res => {
        res.json().then(data => {
            
          setImageOptions(data)
        })
      })

      props.updateComponentHTML(props.id, 
        `<table align="center" border="0" cellpadding="0" cellspacing="0" class="row row-4" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
        <tbody>
            <tr>
                <td>
                    <table align="center" border="0" cellpadding="0" cellspacing="0" class="row-content stack" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; color: #000000; width: 600px;" width="600">
                        <tbody>
                            <tr>
                                <td class="column column-1" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="50%">
                                    <table border="0" cellpadding="0" cellspacing="0" class="image_block block-2" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
                                        <tr>
                                            <td class="pad" style="width:100%;padding-right:0px;padding-left:0px;padding-top:20px;">
                                                <div align="center" class="alignment" style="line-height:10px"><img  src="${image1}" style="display: block; height: auto; border: 0; width: 200px; max-width: 100%;"  width="200"/></div>
                                            </td>
                                        </tr>
                                    </table>
                                    <table border="0" cellpadding="10" cellspacing="0" class="text_block block-3" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; word-break: break-word;" width="100%">
                                        <tr>
                                            <td class="pad" style="padding-top:5px; padding-bottom:5px;">
                                                <div style="font-family: sans-serif">
                                                    <div class="txtTinyMce-wrapper" style="font-size: 12px; font-family: Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif; mso-line-height-alt: 14.399999999999999px; color: #555555; line-height: 1.2;">
                                                        <p style="margin: 0; font-size: 16px; text-align: center;"><strong>${date1}</strong></p>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                    <table border="0" cellpadding="10" cellspacing="0" class="text_block block-4" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; word-break: break-word;" width="100%">
                                        <tr>
                                            <td class="pad" style="padding-top:5px; padding-bottom:5px;">
                                                <div style="font-family: sans-serif">
                                                    <div class="txtTinyMce-wrapper" style="font-size: 12px; font-family: Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif; mso-line-height-alt: 14.399999999999999px; color: #555555; line-height: 1.2;">
                                                        <p style="margin: 0; font-size: 14px; text-align: center;">${info1}</p>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                    <table border="0" cellpadding="0" cellspacing="0" class="button_block block-5" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
                                        <tr>
                                            <td class="pad" style="text-align:center;padding-top:10px;padding-right:10px;padding-bottom:15px;padding-left:10px;">
                                                <div align="center" class="alignment">
                                                    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" style="height:42px;width:86px;v-text-anchor:middle;" arcsize="10%" stroke="false" fillcolor="#de1f26"><w:anchorlock/><v:textbox inset="0px,0px,0px,0px"><center style="color:#ffffff; font-family:Myriad Pro, Arial, sans-serif; font-size:16px"><![endif]-->
                                                        <a href="${buttonLink1}"><div style="text-decoration:none;display:inline-block;color:#ffffff;background-color:#de1f26;border-radius:4px;width:auto;border-top:1px solid #de1f26;font-weight:undefined;border-right:1px solid #de1f26;border-bottom:1px solid #de1f26;border-left:1px solid #de1f26;padding-top:5px;padding-bottom:5px;font-family:Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif;text-align:center;mso-border-alt:none;word-break:keep-all;"><span style="padding-left:20px;padding-right:20px;font-size:16px;display:inline-block;letter-spacing:normal;"><span dir="ltr" style="text-decoration:none; color: #fff; margin: 0; word-break: break-word; line-height: 32px;">${buttonText1}</span></span></div></a>
                                                    <!--[if mso]></center></v:textbox></v:roundrect><![endif]-->
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td class="column column-2" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="50%">
                                <table border="0" cellpadding="0" cellspacing="0" class="image_block block-2" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
                                <tr>
                                    <td class="pad" style="width:100%;padding-right:0px;padding-left:0px;padding-top:20px;">
                                        <div align="center" class="alignment" style="line-height:10px"><img  src="${image2}" style="display: block; height: auto; border: 0; width: 200px; max-width: 100%;"  width="200"/></div>
                                    </td>
                                </tr>
                            </table>
                            <table border="0" cellpadding="10" cellspacing="0" class="text_block block-3" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; word-break: break-word;" width="100%">
                                <tr>
                                    <td class="pad" style="padding-top:5px; padding-bottom:5px;">
                                        <div style="font-family: sans-serif">
                                            <div class="txtTinyMce-wrapper" style="font-size: 12px; font-family: Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif; mso-line-height-alt: 14.399999999999999px; color: #555555; line-height: 1.2;">
                                                <p style="margin: 0; font-size: 16px; text-align: center;"><strong>${date2}</strong></p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <table border="0" cellpadding="10" cellspacing="0" class="text_block block-4" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; word-break: break-word;" width="100%">
                                <tr>
                                    <td class="pad" style="padding-top:5px; padding-bottom:5px;">
                                        <div style="font-family: sans-serif">
                                            <div class="txtTinyMce-wrapper" style="font-size: 12px; font-family: Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif; mso-line-height-alt: 14.399999999999999px; color: #555555; line-height: 1.2;">
                                                <p style="margin: 0; font-size: 14px; text-align: center;">${info2}</p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <table border="0" cellpadding="0" cellspacing="0" class="button_block block-5" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
                                <tr>
                                    <td class="pad" style="text-align:center;padding-top:10px;padding-right:10px;padding-bottom:15px;padding-left:10px;">
                                        <div align="center" class="alignment">
                                            <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" style="height:42px;width:86px;v-text-anchor:middle;" arcsize="10%" stroke="false" fillcolor="#de1f26"><w:anchorlock/><v:textbox inset="0px,0px,0px,0px"><center style="color:#ffffff; font-family:Myriad Pro, Arial, sans-serif; font-size:16px"><![endif]-->
                                            <a href="${buttonLink2}"><div style="text-decoration:none;display:inline-block;color:#ffffff;background-color:#de1f26;border-radius:4px;width:auto;border-top:1px solid #de1f26;font-weight:undefined;border-right:1px solid #de1f26;border-bottom:1px solid #de1f26;border-left:1px solid #de1f26;padding-top:5px;padding-bottom:5px;font-family:Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif;text-align:center;mso-border-alt:none;word-break:keep-all;"><span style="padding-left:20px;padding-right:20px;font-size:16px;display:inline-block;letter-spacing:normal;"><span dir="ltr" style="text-decoration:none; color: #fff; margin: 0; word-break: break-word; line-height: 32px;">${buttonText2}</span></span></div></a>
                                            <!--[if mso]></center></v:textbox></v:roundrect><![endif]-->
                                        </div>
                                    </td>
                                </tr>
                            </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>`)
   }, [])

   useEffect(() => {
      props.updateComponentHTML(props.id,
         `<table align="center" border="0" cellpadding="0" cellspacing="0" class="row row-4" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
         <tbody>
             <tr>
                 <td>
                     <table align="center" border="0" cellpadding="0" cellspacing="0" class="row-content stack" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; color: #000000; width: 600px;" width="600">
                         <tbody>
                             <tr>
                                 <td class="column column-1" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="50%">
                                     <table border="0" cellpadding="0" cellspacing="0" class="image_block block-2" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
                                         <tr>
                                             <td class="pad" style="width:100%;padding-right:0px;padding-left:0px;padding-top:20px;">
                                                 <div align="center" class="alignment" style="line-height:10px"><img  src="${image1}" style="display: block; height: auto; border: 0; width: 200px; max-width: 100%;"  width="200"/></div>
                                             </td>
                                         </tr>
                                     </table>
                                     <table border="0" cellpadding="10" cellspacing="0" class="text_block block-3" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; word-break: break-word;" width="100%">
                                         <tr>
                                             <td class="pad" style="padding-top:5px; padding-bottom:5px;">
                                                 <div style="font-family: sans-serif">
                                                     <div class="txtTinyMce-wrapper" style="font-size: 12px; font-family: Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif; mso-line-height-alt: 14.399999999999999px; color: #555555; line-height: 1.2;">
                                                         <p style="margin: 0; font-size: 16px; text-align: center;"><strong>${date1}</strong></p>
                                                     </div>
                                                 </div>
                                             </td>
                                         </tr>
                                     </table>
                                     <table border="0" cellpadding="10" cellspacing="0" class="text_block block-4" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; word-break: break-word;" width="100%">
                                         <tr>
                                             <td class="pad" style="padding-top:5px; padding-bottom:5px;">
                                                 <div style="font-family: sans-serif">
                                                     <div class="txtTinyMce-wrapper" style="font-size: 12px; font-family: Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif; mso-line-height-alt: 14.399999999999999px; color: #555555; line-height: 1.2;">
                                                         <p style="margin: 0; font-size: 14px; text-align: center;">${info1}</p>
                                                     </div>
                                                 </div>
                                             </td>
                                         </tr>
                                     </table>
                                     <table border="0" cellpadding="0" cellspacing="0" class="button_block block-5" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
                                         <tr>
                                             <td class="pad" style="text-align:center;padding-top:10px;padding-right:10px;padding-bottom:15px;padding-left:10px;">
                                                 <div align="center" class="alignment">
                                                     <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" style="height:42px;width:86px;v-text-anchor:middle;" arcsize="10%" stroke="false" fillcolor="#de1f26"><w:anchorlock/><v:textbox inset="0px,0px,0px,0px"><center style="color:#ffffff; font-family:Myriad Pro, Arial, sans-serif; font-size:16px"><![endif]-->
                                                     <a href="${buttonLink1}"><div style="text-decoration:none;display:inline-block;color:#ffffff;background-color:#de1f26;border-radius:4px;width:auto;border-top:1px solid #de1f26;font-weight:undefined;border-right:1px solid #de1f26;border-bottom:1px solid #de1f26;border-left:1px solid #de1f26;padding-top:5px;padding-bottom:5px;font-family:Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif;text-align:center;mso-border-alt:none;word-break:keep-all;"><span style="padding-left:20px;padding-right:20px;font-size:16px;display:inline-block;letter-spacing:normal;"><span dir="ltr" style="text-decoration:none; color: #fff; margin: 0; word-break: break-word; line-height: 32px;">${buttonText1}</span></span></div></a>
                                                     <!--[if mso]></center></v:textbox></v:roundrect><![endif]-->
                                                 </div>
                                             </td>
                                         </tr>
                                     </table>
                                 </td>
                                 <td class="column column-2" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="50%">
                                 <table border="0" cellpadding="0" cellspacing="0" class="image_block block-2" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
                                 <tr>
                                     <td class="pad" style="width:100%;padding-right:0px;padding-left:0px;padding-top:20px;">
                                         <div align="center" class="alignment" style="line-height:10px"><img  src="${image2}" style="display: block; height: auto; border: 0; width: 200px; max-width: 100%;"  width="200"/></div>
                                     </td>
                                 </tr>
                             </table>
                             <table border="0" cellpadding="10" cellspacing="0" class="text_block block-3" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; word-break: break-word;" width="100%">
                                 <tr>
                                     <td class="pad" style="padding-top:5px; padding-bottom:5px;">
                                         <div style="font-family: sans-serif">
                                             <div class="txtTinyMce-wrapper" style="font-size: 12px; font-family: Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif; mso-line-height-alt: 14.399999999999999px; color: #555555; line-height: 1.2;">
                                                 <p style="margin: 0; font-size: 16px; text-align: center;"><strong>${date2}</strong></p>
                                             </div>
                                         </div>
                                     </td>
                                 </tr>
                             </table>
                             <table border="0" cellpadding="10" cellspacing="0" class="text_block block-4" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; word-break: break-word;" width="100%">
                                 <tr>
                                     <td class="pad" style="padding-top:5px; padding-bottom:5px;">
                                         <div style="font-family: sans-serif">
                                             <div class="txtTinyMce-wrapper" style="font-size: 12px; font-family: Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif; mso-line-height-alt: 14.399999999999999px; color: #555555; line-height: 1.2;">
                                                 <p style="margin: 0; font-size: 14px; text-align: center;">${info2}</p>
                                             </div>
                                         </div>
                                     </td>
                                 </tr>
                             </table>
                             <table border="0" cellpadding="0" cellspacing="0" class="button_block block-5" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
                                 <tr>
                                     <td class="pad" style="text-align:center;padding-top:10px;padding-right:10px;padding-bottom:15px;padding-left:10px;">
                                         <div align="center" class="alignment">
                                             <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" style="height:42px;width:86px;v-text-anchor:middle;" arcsize="10%" stroke="false" fillcolor="#de1f26"><w:anchorlock/><v:textbox inset="0px,0px,0px,0px"><center style="color:#ffffff; font-family:Myriad Pro, Arial, sans-serif; font-size:16px"><![endif]-->
                                             <a href="${buttonLink2}"><div style="text-decoration:none;display:inline-block;color:#ffffff;background-color:#de1f26;border-radius:4px;width:auto;border-top:1px solid #de1f26;font-weight:undefined;border-right:1px solid #de1f26;border-bottom:1px solid #de1f26;border-left:1px solid #de1f26;padding-top:5px;padding-bottom:5px;font-family:Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif;text-align:center;mso-border-alt:none;word-break:keep-all;"><span style="padding-left:20px;padding-right:20px;font-size:16px;display:inline-block;letter-spacing:normal;"><span dir="ltr" style="text-decoration:none; color: #fff; margin: 0; word-break: break-word; line-height: 32px;">${buttonText2}</span></span></div></a>
                                             <!--[if mso]></center></v:textbox></v:roundrect><![endif]-->
                                         </div>
                                     </td>
                                 </tr>
                             </table>
                                 </td>
                             </tr>
                         </tbody>
                     </table>
                 </td>
             </tr>
         </tbody>
     </table>`)
   }, [date1, date2, info1, info2, buttonText1, buttonText2, buttonLink1, buttonLink2, image1, image2])

   function setPreset1(index) {
        let preset = Presets[index];
        setImage1("https://business-butler-media.s3.eu-west-2.amazonaws.com/events-email/" + preset.image);
        setDate1(preset.date);
        setInfo1(preset.info);
        setButtonText1(preset.button);
        setButtonLink1(preset.link)
    }

    function setPreset2(index) {
        let preset = Presets[index];
        setImage2("https://business-butler-media.s3.eu-west-2.amazonaws.com/events-email/" + preset.image);
        setDate2(preset.date);
        setInfo2(preset.info);
        setButtonText2(preset.button);
        setButtonLink2(preset.link)
    }

   return (
      <>
      <h4>Dual Event Row</h4>
      <h4>Event 1</h4>
      <Form.Group controlId="update.preset1">
        <Form.Label>Preset</Form.Label>
            <Form.Control onChange={(event) => setPreset1(event.target.value)} as="select" value={0} >
            {Presets.map((item, index) => {
                return <option value={index}>{item.shortitem}</option>
            })}
            </Form.Control>
      </Form.Group>
      <ImageUploader dirname="events-email" width={1200} height={628} setImageLocation={() => refreshImageOptions()} />
      <Form.Group controlId="update.Image1">
        <Form.Label>Image 1</Form.Label>
            <Form.Control onChange={(event) => setImage1(event.target.value)} as="select" value={image1} >
            {imageOptions.map(item => {
                const shortitem = item.substring(item.lastIndexOf("/") + 1)
                if(shortitem){
                    return <option value={item}>{shortitem}</option>
                }
                else{
                    return(<option value={"https://business-butler-media.s3.eu-west-2.amazonaws.com/email-images/placeholder.png"}>Choose an image:-</option>)
                }

                
            })}
            </Form.Control>
      </Form.Group>
      <Form.Group >
         <Form.Label>Date 1</Form.Label>
         <Form.Control onChange={(event) => setDate1(event.target.value)} value={date1} />
      </Form.Group>
      <Form.Group >
         <Form.Label>Info 1</Form.Label>
         <Form.Control onChange={(event) => setInfo1(event.target.value)} value={info1} />
      </Form.Group>
      <Form.Group >
         <Form.Label>Button Text 1</Form.Label>
         <Form.Control onChange={(event) => setButtonText1(event.target.value)} value={buttonText1} />
      </Form.Group>
      <Form.Group >
         <Form.Label>Button Link 1</Form.Label>
         <Form.Control onChange={(event) => setButtonLink1(event.target.value)} value={buttonLink1} />
      </Form.Group>
      <h4>Event 2</h4>
      <Form.Group controlId="update.preset2">
        <Form.Label>Preset</Form.Label>
            <Form.Control onChange={(event) => setPreset2(event.target.value)} as="select" value={0} >
            {Presets.map((item, index) => {
                return <option value={index}>{item.shortitem}</option>
            })}
            </Form.Control>
      </Form.Group>
      <ImageUploader dirname="events-email" width={1200} height={628} setImageLocation={() => refreshImageOptions()} />
      <Form.Group controlId="update.Image1">
        <Form.Label>Image 2</Form.Label>
            <Form.Control onChange={(event) => setImage2(event.target.value)} as="select" value={image2} >
            {imageOptions.map(item => {
                const shortitem = item.substring(item.lastIndexOf("/") + 1)
                if(shortitem){
                    return <option value={item}>{shortitem}</option>
                }
                else{
                    return(<option value={"https://business-butler-media.s3.eu-west-2.amazonaws.com/email-images/placeholder.png"}>Choose an image:-</option>)
                }

                
            })}
            </Form.Control>
      </Form.Group>
      <Form.Group >
         <Form.Label>Date 2</Form.Label>
         <Form.Control onChange={(event) => setDate2(event.target.value)} value={date2} />
      </Form.Group>
      <Form.Group >
         <Form.Label>Info 2</Form.Label>
         <Form.Control onChange={(event) => setInfo2(event.target.value)} value={info2} />
      </Form.Group>
      <Form.Group >
         <Form.Label>Button Text 2</Form.Label>
         <Form.Control onChange={(event) => setButtonText2(event.target.value)} value={buttonText2} />
      </Form.Group>
      <Form.Group >
         <Form.Label>Button Link 2</Form.Label>
         <Form.Control onChange={(event) => setButtonLink2(event.target.value)} value={buttonLink2} />
      </Form.Group>

      
      </>
   )
}

export default EventRow;